var _path, _ellipse, _path2, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2853 21.5841C23.1821 26.132 19.6735 29.7404 15.4486 29.6421C11.2237 29.5437 7.88245 25.7758 7.98567 21.228C8.03076 19.2415 9.56853 16.0389 11.2864 13.0617C13.3861 9.42262 18.4647 9.54852 20.386 13.2872C21.9533 16.337 23.3304 19.6006 23.2853 21.5841Z",
    fill: "#DAFFF0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.95716,
    cy: 1.95594,
    rx: 1.95716,
    ry: 1.95594,
    transform: "matrix(0.0226904 -0.999743 0.999729 0.0232717 13.8235 15.0508)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5284 18.5375C30.0999 22.8071 28.1597 27.4527 24.1942 28.9123C20.2287 30.3718 15.7397 28.0926 14.1682 23.8231C13.4819 21.9584 13.7377 18.4148 14.2437 15.0144C14.8623 10.8571 19.6331 9.10931 22.791 11.8829C25.3664 14.1451 27.8432 16.6757 28.5284 18.5375Z",
    fill: "#78C2A5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4921,
    cy: 13.4197,
    rx: 1.95738,
    ry: 1.95572,
    transform: "rotate(-110.207 18.4921 13.4197)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.24182619eb9b63e6fb92d9c8149aa803.svg";
export { ForwardRef as ReactComponent };